import VendorSpinResultState from './VendorSpinResultState'
export default class VendorCascadeResultState extends VendorSpinResultState {
    /**
     * This need to be empty for cascade game
     * @param delay 0
     */
    protected stopReels(delay = 0) {
        return
    }
    /**
     * Here need to call exit only for cascade games
     */
    protected setSkipWithSpace() {
        super.setSkipWithSpace();
        this.exit();
    }
}
